module.exports = __webpack_public_path__ + "static/media/468x60_0017_ro.9079a9b5.jpg";